import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  link: { cursor: 'pointer' },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  loader: { marginRight: theme.spacing(1) },
  signed: { display: 'flex', alignItems: 'center' },
  signedIcon: { marginRight: theme.spacing(0.5) },
  button: {
    borderRadius: '4px',
    fontSize: 'large',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    width: 250,
  },
}));

export default function Contract({ openContract }) {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);

  async function handleOpenContract() {
    setLoading(true);
    await openContract(false);
    setLoading(false);
  }

  return (
    <>
      {loading && (
        <div className={classes.loadingContainer}>
          <CircularProgress
            color="primary"
            size={24}
            className={classes.loader}
          />
          <Typography>Preparing agreement</Typography>
        </div>
      )}
      {!loading && (
        <Button
          variant="contained"
          className={classes.button}
          color="primary"
          onClick={handleOpenContract}
        >
          <b>Review {'&'} Sign Contract</b>
        </Button>
      )}
    </>
  );
}
